<div class="mg-cena" [class.mg-cena--parada]="reduzirMovimento" [class.mg-cena--universo]="universoAtivo()" role="group" [attr.aria-label]="'Mapa de fases. ' + xpPercentual + '% da jornada concluída.'">
  <div class="mg-cena__palco">
    <canvas #universo class="mg-cena__universo" aria-hidden="true"></canvas>
    <div class="mg-cena__anel mg-cena__anel--externo"></div>
    <div class="mg-cena__anel mg-cena__anel--medio"></div>
    <div class="mg-cena__anel mg-cena__anel--interno"></div>

    <!-- Os nós percorrem a elipse sem inclinar a área de clique ou o rótulo. -->
    <div class="mg-cena__plano" [style.--angulo-selecionado]="anguloSelecionado">
      @for (fase of fases; track fase.numero; let i = $index) {
        <div class="mg-cena__assento" [class.mg-cena__assento--selecionado]="fase.numero === faseSelecionada" [style.--angulo]="angulo(i)">
          <button
            type="button"
            class="mg-cena__no"
            [class.mg-cena__no--concluida]="fase.concluida"
            [class.mg-cena__no--atual]="fase.atual"
            [class.mg-cena__no--selecionada]="fase.numero === faseSelecionada"
            [style.--i]="i"
            [attr.aria-label]="rotulo(fase)"
            [attr.aria-current]="fase.atual ? 'step' : null"
            [attr.aria-pressed]="fase.numero === faseSelecionada"
            (click)="selecionar.emit(fase.numero)"
          >
            @if (fase.concluida) {
              <mat-icon svgIcon="check_circle" aria-hidden="true"></mat-icon>
            } @else {
              <span aria-hidden="true">{{ fase.numero }}</span>
            }
          </button>
          <span class="mg-cena__rotulo" aria-hidden="true">{{ fase.nome }}</span>
        </div>
      }
    </div>

    <div class="mg-cena__centro" aria-hidden="true">
      <span class="mg-cena__centro-rotulo">Órbita</span>
      <span class="mg-cena__centro-numero">{{ numero(faseSelecionada) }}</span>
      <span class="mg-cena__centro-nome">{{ selecionada?.nome }}</span>
    </div>
  </div>
  <p class="mg-cena__legenda">Explore as órbitas para conhecer cada etapa</p>
</div>
